<!-- <div class="row d-flex justify-content-between px-4 pt-3">
    <h3>Endpoint</h3>
    <div>
        <button type="button" class="btn btn-primary">Create Endpoint</button>
    </div>
</div> -->
<div class="table-container">
<div class=" table-head col-12 d-flex py-3 justify-content-between ">
    <div class="row g-2 d-flex justify-content-between ">
       <h2 style="font-weight: bold;">Endpoint</h2>
        <!-- <div class="pl-3">
            <input type="text" class="form-control" style="border-top-right-radius: 0px;border-bottom-right-radius: 0px;"  style="background-color: transparent;" id="floatingInputGroup1" placeholder="search">
          </div>
          <button type="button" style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"  class="btn btn-primary"><i class='fas fa-search'></i></button> -->

    </div>
    <div>
       <!-- <button class="btn btn-primary" (click)="addNewItem(toggle = !toggle)" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWidthExample" aria-expanded="false" aria-controls="collapseWidthExample">            -->
        <button class="btn btn-primary mr-2" type="button" data-bs-toggle="collapse" data-bs-target="#multiCollapseExample1" aria-expanded="false" aria-controls="multiCollapseExample1">           
          <i class='fas fa-filter'></i>
 </button>
        <button type="button" class="btn btn-primary">Create Endpoint</button>
</div>
   
</div>
</div>
<div class="collapse multi-collapse row pb-4" id="multiCollapseExample1">   
    <div class="col-md">
     <div class="form-floating">
       <input type="email" class="form-control" id="floatingInputGrid" placeholder="Search Keyword" value="Search Keyword">
     </div>
   </div>
   <div class="col-md">
       <div class="form-floating">
         <input type="email" class="form-control" id="floatingInputGrid" placeholder="Select Project" value="Select Project">
       </div>
     </div>
     <div class="col-md">
       <div class="form-floating">
         <input type="email" class="form-control" id="floatingInputGrid" placeholder="Select Endpoint Type" value="Select Endpoint Type">
       </div>
     </div>
     <button type="button" class="btn btn-primary mr-3">Search</button>

 </div>
  <!-- <div class="row">
    <div class="col"> -->
      <!-- <div class="collapse multi-collapse" id="multiCollapseExample1">
        <div class="card card-body">
          Some placeholder content for the first collapse component of this multi-collapse example. This panel is hidden by default but revealed when the user activates the relevant trigger.
        </div>
      </div> -->
    <!-- </div>
  </div> -->
